import React from "react";

import SelectShowsStep from "./SelectShowsStep";
import SelectShowProductsStep from "./SelectShowProductsStep";
import { Step } from "semantic-ui-react";

interface Props {
  defaultFilters: server.dto.ListShowInternalFilters
  initialInstruction: server.dto.PaginatedShowInternalInstruction
  documentId: number
  documentType: server.dto.DocumentTypes
  onLinkedShowsSaved: () => void
}

const LinkShowModal = (props: Props) => {
  const [step, setStep] = React.useState<"selectShows" | "selectProducts">("selectShows");
  const [selectedShows, setSelectedShows] = React.useState<server.dto.ShowForListInternal[]>([]);
  const [lastInstruction, setLastInstruction] = React.useState<server.dto.PaginatedShowInternalInstruction>(null);
  const onNextStep = () => {
    setStep("selectProducts");
  };

  const onShowsSelectedChanged = (shows: server.dto.ShowForListInternal[]) => {
    setSelectedShows(shows);
  };

  const onFilterChanged = (filter: server.dto.PaginatedShowInternalInstruction) => {
    setLastInstruction(filter);
  };

  const onLinkedShowsSaved = async () => {
    props.onLinkedShowsSaved();
  }

  return <>
    <Step.Group>
      <Step onClick={() => { setStep("selectShows"); }} active={step === "selectShows"}>
        <Step.Content>
          <Step.Title>{RESX.Show.Shows}</Step.Title>
        </Step.Content>
      </Step>
      <Step disabled={selectedShows.length === 0} onClick={() => { setStep("selectProducts"); }} active={step === "selectProducts"}>
        <Step.Content>
          <Step.Title>{RESX.Product.Products}</Step.Title>
        </Step.Content>
      </Step>
    </Step.Group>

    {step === "selectShows" && <SelectShowsStep
      selectedShows={selectedShows}
      onSelectedShowsChanged={onShowsSelectedChanged}
      onNextStep={onNextStep}
      defaultFilter={props.defaultFilters}
      initialInstruction={lastInstruction || props.initialInstruction}
      onFilterChanged={onFilterChanged}
    />}

    {step === "selectProducts" && <SelectShowProductsStep
      documentType={props.documentType}
      documentId={props.documentId}
      selectedShows={selectedShows}
      onLinkedShowsSaved={onLinkedShowsSaved}
    />}
  </>;
};

export default LinkShowModal;